import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { AUTOMATION_TEMPLATE_UI } from '@/components/settings/automationTemplatesUi'

type AutomationTemplateConfigureBarProps = {
  onAdd: () => void
  disabled?: boolean
  description?: string
  buttonLabel?: string
}

export function AutomationTemplateConfigureBar({
  onAdd,
  disabled = false,
  description = AUTOMATION_TEMPLATE_UI.configureDescription,
  buttonLabel = AUTOMATION_TEMPLATE_UI.addTemplateButton,
}: AutomationTemplateConfigureBarProps) {
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-border/70 bg-background/80 p-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="space-y-1">
        <div className="text-sm font-medium text-foreground">{AUTOMATION_TEMPLATE_UI.configureTitle}</div>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      <Button type="button" onClick={onAdd} disabled={disabled}>
        <Plus className="mr-2 h-4 w-4" />
        {buttonLabel}
      </Button>
    </div>
  )
}
